import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  min-height: 100vh;
  background: #f8f8f7;
  color: #262b33;
`

export const Hero = styled.section`
  padding: 48px 24px 38px;
  border-bottom: 1px solid #ececec;
  background: #fff;

  @media (max-width: 720px) {
    padding: 34px 16px 28px;
  }
`

export const HeroInner = styled.div`
  width: min(1240px, 100%);
  margin: 0 auto;

  h1 {
    margin: 10px 0 10px;
    font-size: clamp(34px, 4vw, 50px);
    line-height: 1.08;
    letter-spacing: -0.02em;
  }

  p {
    max-width: 720px;
    margin: 0;
    color: #69717d;
    font-size: 15px;
    line-height: 1.6;
  }
`

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 24px;
  color: #666f7b;
  font-size: 12px;
  font-weight: 700;

  &:hover {
    color: #e90000;
  }
`

export const Eyebrow = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e90000;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Count = styled.span`
  display: inline-block;
  margin-top: 16px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f2f3f5;
  color: #6d7480;
  font-size: 10px;
  font-weight: 800;
`

export const Container = styled.section`
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
  padding: 42px 0 68px;

  @media (max-width: 720px) {
    width: calc(100% - 28px);
    padding: 28px 0 44px;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.article`
  overflow: hidden;
  border: 1px solid #e7e8ea;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(20, 24, 31, 0.04);
`

export const Image = styled.img`
  width: 100%;
  height: 205px;
  display: block;
  object-fit: cover;
`

export const CardBody = styled.div`
  padding: 18px;

  h2 {
    margin: 9px 0 8px;
    font-size: 18px;
    line-height: 1.3;

    a {
      color: #222831;
    }

    a:hover {
      color: #e90000;
    }
  }

  p {
    margin: 0 0 13px;
    color: #6e7682;
    font-size: 12px;
    line-height: 1.55;
  }
`

export const Badge = styled.span`
  display: inline-flex;
  padding: 5px 8px;
  border-radius: 999px;
  background: #f0f4fa;
  color: #40516c;
  font-size: 8px;
  font-weight: 900;
  text-transform: uppercase;
`

export const Meta = styled.small`
  color: #9299a4;
  font-size: 9px;
`

export const State = styled.div`
  padding: 38px 20px;
  border: 1px dashed #dfe3e8;
  border-radius: 14px;
  background: #fff;
  color: #7d8591;
  text-align: center;

  button {
    display: block;
    margin: 14px auto 0;
    padding: 10px 16px;
    border: 0;
    border-radius: 9px;
    background: #e90000;
    color: #fff;
    font-weight: 800;
    cursor: pointer;
  }
`

export const LoadMore = styled.button`
  min-width: 150px;
  min-height: 42px;
  margin: 30px auto 0;
  padding: 0 18px;
  border: 0;
  border-radius: 10px;
  display: block;
  background: #e90000;
  color: #fff;
  font-weight: 800;
  cursor: pointer;

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`
